import { IProjectInstallationTimeline, ISiteRecceeRemarks } from '@api/models';
import { getProjectInstallationById, getProjectInstallationTimeline } from '@api/services/project-installation.service';
import useDataQuery from '@hooks/use-data-query';
import useDialog from '@hooks/use-dialog';
import { Button, Card, CircularProgress } from '@hyperflake/react-ui-library';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import RemarkSiteRecceDrawer from '../RemarkSiteRecceDrawer/RemarkSiteRecceDrawer';
import { DeleteIcon } from '@icon/index';
import { Popover } from '@library/popover';
import { useState } from 'react';
import moment from 'moment';
import { TRootState } from '@store/index';
import { useSelector } from 'react-redux';
interface SiteRecceRemarksTimelineProps {
    isLoading?: boolean;
    data?: ISiteRecceeRemarks[];
    handleAddRemarks: (remarks: string) => void;
    handleRemoveRemark: (id: string) => void;
}

const SiteRecceRemarksTimeline = (props: SiteRecceRemarksTimelineProps) => {
    const { data, isLoading = false, handleAddRemarks, handleRemoveRemark } = props;
    const addRemarksSiteRecceDialog = useDialog();
    const [openPopoverRemarkId, setOpenPopoverRemarkId] = useState<string | null>(null);

    const { info: user } = useSelector((state: TRootState) => state.profile);

    // const { clientInstallationId, projectInstallationId } = useParams();

    // const projectInstallationQuery = useDataQuery(
    //     ['project-timeline', clientInstallationId, projectInstallationId],
    //     () => getProjectInstallationTimeline(clientInstallationId, projectInstallationId),
    //     {
    //         enabled: Boolean(clientInstallationId && projectInstallationId),
    //     }
    // );

    if (isLoading) {
        return (
            <Card className="mt-4">
                <Card.Header>Remarks</Card.Header>
                <Card.Body className="flex justify-center items-center">
                    <CircularProgress size={30} />
                </Card.Body>
            </Card>
        );
    }

    // if (projectInstallationQuery.isError) {
    //     toast.error('Failed to fetch timeline data');
    //     return null;
    // }

    // const timelineData: IProjectInstallationTimeline[] = projectInstallationQuery.data;

    return (
        <>
            <Card className="mt-4">
                <Card.Header className="flex justify-between items-center">
                    <div>Remarks</div>
                    <div>
                        <Button size="sm" onClick={() => addRemarksSiteRecceDialog.show()}>
                            Add Remarks
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="space-y-4">
                        {data && data.length > 0 ? (
                            data.map((timelineItem, index) => (
                                <div className="flex justify-between items-center">
                                    <div key={index} className="flex items-start space-x-4">
                                        <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white mt-1">
                                            {index + 1}
                                        </div>
                                        <div>
                                            <div className="text-lg font-semibold">
                                                {/* {timelineItem.details ? (
                                            <>
                                                <div className="mb-1">
                                                    <span className="font-medium">Status:</span>{' '}
                                                    {timelineItem.projectTimeLineStatus.replace(/_/g, ' ')}
                                                </div>
                                                <div className="">
                                                    <div className="space-y-1 text-sm text-gray-500 border-2 m-2 p-2">
                                                        {Object.entries(timelineItem.details).map(
                                                            ([key, value]: [string, any]) => (
                                                                <div key={key} className="mt-2">
                                                                    <span className="font-medium capitalize text-gray-700 ">
                                                                        {key}:
                                                                    </span>
                                                                    <div className="flex items-center gap-2 px-2 ">
                                                                        <span className="  ">
                                                                            from: {value?.from ?? 'N/A'}
                                                                        </span>
                                                                        <span className="text-gray-400">:</span>
                                                                        <span className=" ">
                                                                            to: {value?.to ?? 'N/A'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            timelineItem.message
                                        )} */}
                                                {timelineItem.message}
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                {/* {new Date(timelineItem.createdAt).toLocaleString()} */}
                                                {moment
                                                    .tz(timelineItem.createdAt, user.timezone)
                                                    .format('h:mm a [·] DD MMM, YYYY')}
                                            </div>
                                            <div className="text-sm text-gray-600">
                                                <span className="font-medium">By:</span> {timelineItem.user.name}
                                            </div>
                                            {/* <div className="mt-1">
                                        <span className="font-medium">Status:</span>{' '}
                                        {timelineItem.projectTimeLineStatus}
                                    </div> */}
                                            {/* <div className="mt-2">
                                        <span className="font-medium">User:</span> {timelineItem.user}
                                    </div> */}
                                        </div>
                                    </div>

                                    <div className="mr-10">
                                        <Popover
                                            placement="top-start"
                                            contentClassName="px-6 py-5 rounded-2xl shadow-lg w-[380px]"
                                            open={openPopoverRemarkId === timelineItem._id}
                                            setOpen={(open) => setOpenPopoverRemarkId(open ? timelineItem._id : null)}
                                            content={
                                                <div>
                                                    <p className="text-sm text-grayscale-500">
                                                        Are you sure you want to remove this Remark?
                                                    </p>

                                                    <div className="flex gap-3 mt-4">
                                                        <Button
                                                            size="xs"
                                                            color="primary"
                                                            onClick={() => {
                                                                handleRemoveRemark(timelineItem._id);
                                                                setOpenPopoverRemarkId(null);
                                                            }}
                                                        >
                                                            Delete
                                                        </Button>
                                                        <Button
                                                            size="xs"
                                                            variant="shaded"
                                                            onClick={() => setOpenPopoverRemarkId(null)}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                </div>
                                            }
                                        >
                                            <Button
                                                variant="text"
                                                size="xs"
                                                // disabled={isRemoving}
                                            >
                                                <DeleteIcon />
                                            </Button>
                                        </Popover>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>No Remarks Available.</p>
                        )}
                    </div>
                </Card.Body>
            </Card>
            <RemarkSiteRecceDrawer
                onClose={addRemarksSiteRecceDialog.hide}
                open={addRemarksSiteRecceDialog.isOpen}
                onSubmit={(remarks) => handleAddRemarks(remarks)}
            />
        </>
    );
};

export default SiteRecceRemarksTimeline;
